import Spacer from '@berlitz/spacer'
import DashboardCard from '@components/DashboardCard'
import { ProgramStudentInfo } from '@interfaces/Student'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import { CardSpan, StyledCol } from './style'

const CardGroupLeader: React.FunctionComponent<ProgramStudentInfo> = ({ IsGroup, IsLead }) =>
  IsGroup && IsLead ? (
    <StyledCol xs={12} sm={6} md={6} lg={3}>
      <DashboardCard color="info20" img="/images/group.svg" info="Don't forget">
        <CardSpan>
          <Spacer size="xxs" />
          <FormattedMessage id="You are the lead student for your group. You are scheduling lessons for all attendees." />
        </CardSpan>
      </DashboardCard>
    </StyledCol>
  ) : null

export default CardGroupLeader
